// Brand constants for Crown Jewels Sisterhood Houston

export const BRAND = {
  name: "Crown Jewels Sisterhood",
  city: "Houston, TX",
  mcEst: 2020,
  scEst: 2021,
  motto: "Like precious jewels, our sisterhood is rare.",
  patchImage:
    "https://customer-assets.emergentagent.com/job_crown-riders-hub/artifacts/xvycfxyj_Screenshot_20260413-105017_Messenger~2.png",
  logoImage:
    "https://customer-assets.emergentagent.com/job_crown-riders-hub/artifacts/w4ym4v6v_Screenshot_20260419-192544_Facebook~2.png",
  emails: {
    mc: "Crownjewelsmc@gmail.com",
    sc: "Crownjewelssc@gmail.com",
  },
  // Official social handles
  social: {
    instagram: "https://www.instagram.com/crownjewels_MC",
    facebook: "https://www.facebook.com/people/Crown-Jewels-MC-Houston/100068783602520/",
    facebookMcGroup: "https://www.facebook.com/groups/386585095542679/",
    facebookScGroup: "https://www.facebook.com/groups/6871364616264385/",
    youtube: "https://www.youtube.com/@CrownJewelsMC",
    tiktok: "https://www.tiktok.com/@crownjewels_mc",
  },
  images: {
    hero: "/gallery/ride-17.jpg",
    aboutRiders: "/gallery/ride-22.jpg",
    mcBranch: "/gallery/ride-14.jpg",
    scBranch: "/gallery/mc-group.jpg",
    missCrownJewels:
      "https://customer-assets.emergentagent.com/job_crown-riders-hub/artifacts/kfyclqa0_Screenshot_20221115-174403.png",
    houston: "/gallery/ride-16.jpg",
    gallery: [
      "/gallery/mc-group.jpg",
      "/gallery/pink-friday-flyer.jpg",
      "/gallery/nice-nasty-flyer.jpg",
      "/gallery/ride-01.jpg",
      "/gallery/ride-02.jpg",
      "/gallery/ride-03.jpg",
      "/gallery/ride-04.jpg",
      "/gallery/ride-05.jpg",
      "/gallery/ride-06.jpg",
      "/gallery/ride-07.jpg",
      "/gallery/ride-08.jpg",
      "/gallery/ride-09.jpg",
      "/gallery/ride-10.jpg",
      "/gallery/ride-11.jpg",
      "/gallery/ride-12.jpg",
      "/gallery/ride-13.jpg",
      "/gallery/ride-14.jpg",
      "/gallery/ride-15.jpg",
      "/gallery/ride-16.jpg",
      "/gallery/ride-17.jpg",
      "/gallery/ride-18.jpg",
      "/gallery/ride-19.jpg",
      "/gallery/ride-20.jpg",
      "/gallery/ride-21.jpg",
      "/gallery/ride-22.jpg",
      "/gallery/ride-23.jpg",
      "/gallery/ride-24.jpg",
      "/gallery/clip-01.mp4",
    ],
  },
  // Miss Crown Jewels roster (ages 2-17 youth mentorship)
  missCrownJewels: [
    { name: "Liya",              image: "/miss-crown-jewels/liya.png" },
    { name: "Lil Diamond",       image: "/miss-crown-jewels/lil-diamond.png" },
    { name: "Gangsta Boo",       image: "/miss-crown-jewels/gangsta-boo.png" },
    { name: "Alex B",            image: "/miss-crown-jewels/alex-b.png" },
    { name: "Aly",               image: "/miss-crown-jewels/aly.png" },
    { name: "Pumpkin",           image: "/miss-crown-jewels/pumpkin.png" },
    { name: "Princess",          image: "/miss-crown-jewels/princess.png" },
    { name: "Cupcake Sprinkles", image: "/miss-crown-jewels/cupcake-sprinkles.jpg" },
  ],
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Our Story", href: "#about" },
  { label: "The Branches", href: "#branches" },
  { label: "The Board", href: "#officers" },
  { label: "Miss Crown Jewels", href: "#miss" },
  { label: "Events", href: "#events" },
  { label: "Gallery", href: "#gallery" },
  { label: "Join Us", href: "#join" },
  { label: "Contact", href: "#contact" },
];
